// Central on-site engagement tracking. Anonymous visitor id persists across
// sessions; events are POSTed to the backend engagement log.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function getVisitorId() {
  let id = localStorage.getItem("oh_visitor_id");
  if (!id) {
    id = crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("oh_visitor_id", id);
  }
  return id;
}

export function getSessionId() {
  let sid = localStorage.getItem("oh_visitor_sid");
  if (!sid) {
    sid = crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("oh_visitor_sid", sid);
  }
  return sid;
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

// First-touch marketing attribution — captured once and persisted for the visitor.
export function captureAttribution() {
  try {
    if (localStorage.getItem("oh_attribution")) return;
    const params = new URLSearchParams(window.location.search);
    const attr = { referrer: (document.referrer || "").slice(0, 300),
      landing_page: (window.location.pathname + window.location.search).slice(0, 300),
      device: /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? "mobile" : "desktop" };
    UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) attr[k] = v.slice(0, 120); });
    localStorage.setItem("oh_attribution", JSON.stringify(attr));
  } catch (_) {}
}

export function getAttribution() {
  captureAttribution();
  try { return JSON.parse(localStorage.getItem("oh_attribution") || "{}"); }
  catch (_) { return {}; }
}

export function trackEvent(type, payload = {}) {
  try {
    captureAttribution();
    return fetch(`${BACKEND}/api/track/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        path: window.location.pathname,
        ...payload,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    return Promise.resolve();
  }
}
